import { render, staticRenderFns } from "./AllFtpUsers.vue?vue&type=template&id=21229b97&"
import script from "./AllFtpUsers.vue?vue&type=script&lang=ts&"
export * from "./AllFtpUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports